import { useSetAtom } from 'jotai';
import { useCallback, useEffect } from 'react';
import { panelCloseHandlerAtom } from '../atoms/session-atoms';
export const usePanelCloseHandler = _ref => {
  let {
    onCloseAttemptBI,
    handleCloseWithModal
  } = _ref;
  const setPanelCloseHandler = useSetAtom(panelCloseHandlerAtom);
  const handler = useCallback(closePanelDirectly => {
    onCloseAttemptBI == null || onCloseAttemptBI();
    return handleCloseWithModal(closePanelDirectly);
  }, [onCloseAttemptBI, handleCloseWithModal]);
  useEffect(() => {
    setPanelCloseHandler(handler);
    return () => {
      setPanelCloseHandler(undefined);
    };
  }, [setPanelCloseHandler, handler]);
};
//# sourceMappingURL=use-panel-close-handler.js.map